export default function HeroSection() {
  const scrollToBooking = () => {
    const el = document.querySelector('#booking');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    const el = document.querySelector('#services');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/813da42d69b5fcd77669665d452f6218.jpg"
          alt="Luxury Prom Chauffeur Philadelphia"
          className="w-full h-full object-cover object-top"
        />
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/85"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40"></div>
      </div>

      {/* Sparkle dots */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 rounded-full bg-white"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 80}%`,
              opacity: Math.random() * 0.6 + 0.2,
              animation: `sparkle ${Math.random() * 2 + 2}s ease-in-out infinite`,
              animationDelay: `${Math.random() * 3}s`,
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 w-full max-w-4xl mx-auto pt-28 md:pt-0">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 silver-border rounded-full px-5 py-2 mb-8 animate-fade-in">
          <div className="w-1.5 h-1.5 rounded-full bg-gray-300"></div>
          <span className="text-gray-300 text-xs tracking-[0.25em] uppercase font-medium">
            Philadelphia's Premier Prom Experience
          </span>
          <div className="w-1.5 h-1.5 rounded-full bg-gray-300"></div>
        </div>

        {/* Main Title */}
        <h1 className="font-display silver-gradient-text text-6xl md:text-8xl font-semibold tracking-[0.12em] uppercase leading-none mb-3 animate-fade-in-up">
          Luxury Prom
        </h1>
        <h2 className="font-display text-white text-2xl md:text-4xl font-light tracking-[0.35em] uppercase mb-8 animate-fade-in-up delay-200">
          Chauffeur Experience
        </h2>

        {/* Tagline */}
        <p className="font-display text-gray-300 text-xl md:text-2xl italic font-light mb-12 animate-fade-in-up delay-400">
          "Arrive in Style. Leave an Impression."
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up delay-600">
          <button
            onClick={scrollToBooking}
            className="btn-silver rounded-full px-10 py-4 text-xs tracking-[0.2em] uppercase cursor-pointer whitespace-nowrap"
          >
            Reserve Your Date
          </button>
          <button
            onClick={scrollToServices}
            className="btn-outline-silver rounded-full px-10 py-4 text-xs tracking-[0.2em] uppercase cursor-pointer whitespace-nowrap"
          >
            View Fleet &amp; Pricing
          </button>
        </div>

        {/* Stats */}
        <div className="flex flex-col sm:flex-row gap-8 justify-center mt-16 animate-fade-in delay-800">
          <div className="text-center">
            <p className="font-display silver-gradient-text text-3xl font-semibold">2026</p>
            <p className="text-gray-500 text-xs tracking-[0.15em] uppercase mt-1">BMW Fleet</p>
          </div>
          <div className="hidden sm:block w-px bg-gray-700"></div>
          <div className="text-center">
            <p className="font-display silver-gradient-text text-3xl font-semibold">100%</p>
            <p className="text-gray-500 text-xs tracking-[0.15em] uppercase mt-1">Professional</p>
          </div>
          <div className="hidden sm:block w-px bg-gray-700"></div>
          <div className="text-center">
            <p className="font-display silver-gradient-text text-3xl font-semibold">Philadelphia</p>
            <p className="text-gray-500 text-xs tracking-[0.15em] uppercase mt-1">Exclusive Service</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-fade-in delay-800">
        <span className="text-gray-500 text-xs tracking-[0.2em] uppercase">Scroll</span>
        <div className="w-px h-8 bg-gradient-to-b from-gray-500 to-transparent"></div>
      </div>
    </section>
  );
}
